// Shared admin auth for the password-gated admin pages
// (Manage, EpisodeCreator, PuraskaraluAdmin).
//
// Why this exists: each page used to manage its own `isAuthenticated`
// state locally, so users had to re-enter the password every time they
// jumped between admin pages. We now stash a flag in sessionStorage so a
// single login covers all of them for the duration of the browser tab.
//
// Notes:
//   * The password is a client-side gate, not real security — it's
//     bundled into the JS like before. Treat it as a polite "are you
//     supposed to be here?" prompt, nothing more.
//   * Scope is sessionStorage (not localStorage) so closing the tab
//     forgets you. Matches the prior behaviour where a reload also
//     forgot you.
//   * The Jeedigunta trophy report page checks this same value (`kk26`)
//     against the SECURITY DEFINER RPCs directly rather than importing this
//     module — as of 2026-07-07 the two are deliberately unified, not
//     separate (they used to differ on purpose; changed on request).

export const ADMIN_PASSWORD = "kk26";

const STORAGE_KEY = "kathakala_admin_auth";

export const isAdminAuthenticated = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const setAdminAuthenticated = (value) => {
  try {
    if (value) {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // sessionStorage can throw in private-browsing edge cases; the
    // page's local React state still works, just without persistence.
  }
};
